module.exports = __webpack_public_path__ + "img/AttachingFiles.4ef1d316.svg";